export default __webpack_public_path__ + "cf185bee5234a0ff498f8a57d53d16fb.png";